import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import type { Auth } from "@/serializers";

type SentryUserSyncProps = {
  auth: Auth;
};

export function SentryUserSync({ auth }: SentryUserSyncProps) {
  const userId = auth.user?.id;

  useEffect(() => {
    if (!Sentry.isEnabled()) return;

    if (!userId) {
      Sentry.setUser(null);
      return;
    }

    Sentry.setUser({ id: String(userId) });
  }, [userId]);

  return null;
}
